// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__kBY55","right":"Footer_right__1VH9E","buttons":"Footer_buttons__krMHO"};